/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { Http, Response } from '@angular/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Rx';
import { SFShiftScheduleSF6 } from '../../models/SFShiftScheduleSF6';
import { SocketConnection } from '../../sockets/socket.connections';


/**
 * Api services for the `SFShiftScheduleSF6` model.
 */
@Injectable()
export class SFShiftScheduleSF6Api extends BaseLoopBackApi {

  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, searchParams, errorHandler);
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `params` – `{Object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `hasil` – `{Object}` - 
   */
  public procsave(params: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFShiftScheduleSF6s/procsave";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `empid` – `{string}` - 
   *
   *  - `company_id` – `{string}` - 
   *
   *  - `shiftdate` – `{string}` - 
   *
   *  - `defaultshift` – `{string}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `hasil` – `{Object}` - 
   */
  public getDefaultShift(empid: any = {}, company_id: any = {}, shiftdate: any, defaultshift: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFShiftScheduleSF6s/getDefaultShift";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof empid !== 'undefined' && empid !== null) _urlParams.empid = empid;
    if (typeof company_id !== 'undefined' && company_id !== null) _urlParams.company_id = company_id;
    if (typeof shiftdate !== 'undefined' && shiftdate !== null) _urlParams.shiftdate = shiftdate;
    if (typeof defaultshift !== 'undefined' && defaultshift !== null) _urlParams.defaultshift = defaultshift;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `list_empid` – `{any}` - 
   *
   *  - `company_id` – `{string}` - 
   *
   *  - `startdate` – `{date}` - 
   *
   *  - `enddate` – `{date}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFShiftScheduleSF6` object.)
   * </em>
   */
  public getEmpShift(list_empid: any, company_id: any, startdate: any, enddate: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFShiftScheduleSF6s/getEmpShift";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof list_empid !== 'undefined' && list_empid !== null) _urlParams.list_empid = list_empid;
    if (typeof company_id !== 'undefined' && company_id !== null) _urlParams.company_id = company_id;
    if (typeof startdate !== 'undefined' && startdate !== null) _urlParams.startdate = startdate;
    if (typeof enddate !== 'undefined' && enddate !== null) _urlParams.enddate = enddate;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `list_empid` – `{any}` - 
   *
   *  - `startdate` – `{date}` - 
   *
   *  - `enddate` – `{date}` - 
   *
   *  - `defaultshift` – `{string}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `hasil` – `{any}` - 
   */
  public getMatrixAttendance(list_empid: any, startdate: any, enddate: any, defaultshift: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFShiftScheduleSF6s/getMatrixAttendance";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof list_empid !== 'undefined' && list_empid !== null) _urlParams.list_empid = list_empid;
    if (typeof startdate !== 'undefined' && startdate !== null) _urlParams.startdate = startdate;
    if (typeof enddate !== 'undefined' && enddate !== null) _urlParams.enddate = enddate;
    if (typeof defaultshift !== 'undefined' && defaultshift !== null) _urlParams.defaultshift = defaultshift;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `SFShiftScheduleSF6`.
   */
  public getModelName() {
    return "SFShiftScheduleSF6";
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/SFShiftScheduleSF6.ts